<template>
  <div>
    <div class="container-fluid">
      <div class="row banner align-items-center">
        <div class="col-md-6 col-12">
          <div class="personal_info">
            <div class="d-flex">
              <img style="max-width:200px; min-width:150px;" :src="schoolInfo.logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="d-flex menu">
            <div @click="goPage('GroupManagement')"  class="title d-sm-flex pointer" :class="{'active' : $route.name === 'GroupManagement'}">
              <img style="height:30px" src="../assets/image/pic/icon_tag.png" alt="">
              <div class="my-auto">
                {{ copy.groupManagement }}
              </div>
            </div>
            <div @click="goPage('AiSummary')"  class="title d-sm-flex pointer" :class="{'active' : $route.name.substr(0,2)==='Ai'}">
              <img style="height:30px" src="../assets/image/pic/icon_tag.png" alt="">
              <div class="my-auto">
                {{ copy.aiPointManagement }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <router-view :inputEnterpriseId="enterpriseId"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import Video from '@/components/Video.vue'
import { mapActions } from 'vuex'
import api from '../store/api'
export default {
  name: 'Campus',
  data () {
    return {
      enterpriseId: 0,
      groupId: 0,
      schoolInfo: {},
      title: this.$route.name
    }
  },
  ...mapActions({
    getUser: 'getUser'
  }),
  computed: {
    currentLocale () {
      return this.$i18n ? this.$i18n.locale : 'tw'
    },
    copy () {
      const copy = {
        tw: {
          groupManagement: '班級管理',
          aiPointManagement: 'AI點數管理'
        },
        en: {
          groupManagement: 'Class Management',
          aiPointManagement: 'AI Points Management'
        }
      }

      return copy[this.currentLocale] || copy.tw
    }
  },
  mounted() {
    this.scrollTop()
    this.getPersonalData()

  },
  methods: {
    goPage (el) {
      this.title = el
      this.$router.push({ name: el, params:{ groupId: this.groupId}})
    },
    async getPersonalData () {
      const user = this.$store.state.auth.user
      this.getSchoolInfo(user.enterprise_id)
      this.enterpriseId = user.enterprise_id
      this.groupId = user.group_id
    },
    async getSchoolInfo(id) {
      const { data } = await api.get(`enterprises/${id}`)
      this.schoolInfo = data.data
    },
    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    }
  },
  components: {
  }
}
</script>
<style lang="scss" scoped>
  .banner {
    min-height: 250px;
    background-image: url('../assets/image/pic/bg_member_top.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .cefr {
      padding: 2px;
      font-size: 1rem;
      line-height: 1rem;
      background-color: rgb(255, 0, 0);
      border: 2px solid #fff;
      border-radius: 20%;
    }
    h2 {
      margin: 0;
    }
  }
  .main {
    background-color: #eee;
  }
  .main-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: red;
  }
  .circle_picture {
    width: 100px;
    height: 100px;
    border-radius:50%;
  }
  .personal_info {
    text-align: left;
    color: #fff;
    position: absolute;
    top:50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .active {
    color: red;
    font-weight: bolder;
  }
  .info-box {
    margin: 10px;
    .title {
      padding: 3px;
      min-width: 150px;
      background-color: #fff;
      font-weight: bold;
      color: #51A8DD;
    }
    select {
      width: 100%;
      padding: 10px;
      border: none;
      border-top: 1px solid #ccc;
    }
    .content {
      white-space:nowrap;
      padding: 10px;
      color: #fff;
      border: 1px #fff solid;
    }
  }
  .menu {
    .title {
      margin: 20px;
      font-weight: bolder;
    }
  }
  @media(max-width: 1080px){
    .banner {
      height: 55vh;
    }
    .personal_info {
      margin-top: 8vh;
    }
    .group_info {
      margin-top: 8vh;
      .info-box {
        margin: 20px;
      }
    }
  }
</style>
